import Vue from "vue";
import features from "../features.json";

const CURRENT_TARGET = process.features.target || ["dev"];

const feature = new Vue({
  computed: {
    currentTarget() {
      return CURRENT_TARGET;
    },
    isTesting() {
      return CURRENT_TARGET.includes("test");
    },
    isAudiTarget() {
      return CURRENT_TARGET.includes("audi");
    },
    isDBTarget() {
      return CURRENT_TARGET.includes("deutscheBahn");
    },
    isPorscheTarget() {
      return CURRENT_TARGET.includes("porsche");
    },
  },
  methods: {
    isEnabled(name) {
      if (!features[name] || !features[name].target) {
        console.error("Unknown feature: " + name);
        return false;
      }

      let targets = features[name].target.split(" ");
      return targets.includes(CURRENT_TARGET);
    },
    isDisabled(name) {
      return !this.isEnabled(name);
    },
  },
});

export default feature;



// WEBPACK FOOTER //
// ./src/feature.js